import React from "react";

import './../App.css';

export const Health = () => {
  return (
    <health> OK </health>
  );
};
